import type { FC, ReactNode } from 'react'

import { motion } from 'motion/react'
import { enter } from '@/lib/motion'
import { HeroHeading } from '@/components/site/hero-heading'
import { Button } from '@/components/site/button'

export const AboutHero: FC = (): ReactNode => {
    return (
        <section
            id='hero'
            className='relative z-[2] flex h-[56vh] w-full flex-col items-end justify-end overflow-clip bg-background px-4 pb-6 pt-hero md:h-[40vh] lg:h-[56vh] lg:px-6'
        >
            <div className='flex w-full flex-col items-end gap-6 md:max-w-[76%] md:flex-row md:items-end md:justify-start lg:max-w-[68%]'>
                <div className='w-full md:flex-1'>
                    <HeroHeading
                        first="The person"
                        connector="behind"
                        second="The code"
                        align='start'
                    />
                </div>

                <motion.div
                    className='flex w-min flex-col items-center gap-4 py-4'
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={enter(0.5)}
                >
                    <Button href='/contact' label="Work with me" size='sm' />
                </motion.div>
            </div>
        </section>
    )
}
